<template>
  <div class="law-page">
    <div class="top-banner">
      <img :src="baseUrl + '/product-bg.png'" alt="Banner" class="banner-image" />

      <div class="banner-info">
        <div class="title">行业资讯跟踪</div>
        <div class="space"></div>
        <div class="info">专注于医疗垂直领域大数据服务，依托海量权威公众号文章资源，构建覆盖临床诊疗、医学研究政策解读、健康科普、行业趋势的全维度知识库。</div>
        <div class="info">严格遵循《网络安全法》《医疗数据合规指南》，采用去标识化处理技术，已为12家医疗客户提供合规数据资产解决方案。让数据成为您的“医疗战略望远镜”</div>
        <div class="btn">
          <img :src="baseUrl + '/btn.png'" class="btn" alt="">
        </div>
      </div>
    </div>

    <div  class="news-main">
      <div class="section-title">
        <h2>服务介绍</h2>
        <div class="title-underline"></div>
      </div>

      <div class="service-box">
        <div class="info-box">
          <div class="title">
            <span class="bold">聚合卫健委、药监局等官方新闻发布平台与500+垂直领域优质公众号。</span>
            通过AI语义分析+人工医学审核双引擎，实现：
          </div>
          <div class="info-line">
            <div class="label">🔍 <span class="bold">权威溯源：</span></div>
            <div class="desc">实时抓取政府公告、权威机构白皮书、三甲医院专家解读，确保信息源头可靠</div>
          </div>
          <div class="info-line">
            <div class="label">🔍 <span class="bold">动态预警：</span></div>
            <div class="desc">监测医保政策调整、器械审批动态、疾病流行趋势，抢占行业先机</div>
          </div>
          <div class="info-line">
            <div class="label">🔍 <span class="bold">深度解构：</span></div>
            <div class="desc">关联分析政策导向与市场数据（如集采影响、科室建设风向），输出可视化报告</div>
          </div>
          <div class="info-line">
            <div class="label">🔍 <span class="bold">精准触达：</span></div>
            <div class="desc">支持按 <span class="bold">产品关键词、地域、机构类型</span> 定制数据包，直击科研、投资、运营场景需求 </div>
          </div>

        </div>
        <img :src="baseUrl + '/news-table.png'" class="table-img" alt="">
      </div>

      <div class="section-title">
        <h2>适用场景</h2>
        <div class="title-underline"></div>
      </div>


      <div class="scene-box">
        <div class="item bg1">
          <img :src="baseUrl + '/title1.png'" class="title" alt="">
        </div>
        <div class="item bg2">
          <img :src="baseUrl + '/title2.png'" class="title" alt="">
        </div>
        <div class="item bg3">
          <img :src="baseUrl + '/title3.png'" class="title" alt="">
        </div>
        <div class="item bg4">
          <img :src="baseUrl + '/title4.png'" class="title" alt="">
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { baseUrl } from '@/utils';

</script>

<style lang="less" scoped>
.law-page {
  position: relative;
  min-height: 100vh;
  min-width: 1400px;
  background: #fff;
  padding-bottom: 30px;
  .banner-info {
    position: absolute;
    right: 100px;
    top: 0;
    height: 600px;
    padding-bottom: 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    .title {
      font-family: YouSheBiaoTiHei;
      font-size: 72px;
      line-height: 90px;
      color: #101010;
    }
    .space {
      width: 160px;
      height: 24px;
      margin: 32px 0 44px;
      background: linear-gradient(228.23deg, rgba(35,19,176,0.83) 12.42%,rgba(128,152,219,0.9) 47.6%,rgba(135,183,219,0.82) 73.98%,rgba(165,227,255,0.75) 97.43%);
    }
    .info {
      width: 850px;
      
      font-size: 20px;
      line-height: 35px;
      color: #101010;
      text-align: right;
    }
    .btn {
      margin-top: 40px;
      img {
        width: 200px;
        cursor: pointer;
        transition: all .3s;
        &:hover {
          transform: scale(1.02);
        }
      }
    }
  }

  .top-banner {
    width: 100%;
    height: 600px;
    overflow: hidden;

    .banner-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }
  .news-main  {
    width: 1400px;
    margin: 0 auto;
    .service-box {
      width: 100%;
      height: 600px;
      margin-bottom: 100px;
      position: relative;
      background: linear-gradient(-44.13deg, rgba(187,216,255,0.82) 1.73%,rgba(137,219,228,0.27) 49.96%,rgba(253,247,244,0.44) 78.5%,rgba(255,255,255,0.68) 91.29%);
      box-shadow: 2px 2px 6px 0px rgba(0,0,0,0.4);
      border-radius: 24px;
      .table-img {
        position: absolute;
        right: -36px;
        bottom: 0;
        width: 700px;
      }
      .info-box {
        width: 700px;
        padding-left: 48px;
        padding-top: 50px;
        
        font-size: 24px;
        color: rgba(16, 16, 16, .7);
        text-align: left;
        line-height: 40px;
        .title {
          margin-bottom: 20px;
        }
        .bold {
          font-weight: bold;
          color: #101010;
        }
        .info-line {
          display: flex;
          margin-bottom: 10px;
          .label {

          }
          .desc {
            flex: 1;
          }
        }
      }
    }
  }

  .section-title {
    text-align: left;
    margin-bottom: 60px;
    
    h2 {
      
      font-size: 48px;
      color: #101010;
      margin-bottom: 10px;
    }
    
    .title-underline {
      width: 440px;
      height: 7px;
      background: #1e40af;
    }
  }

  .scene-box {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 30px;
    margin-bottom: 50px;
    .item {
      width: 670px;
      height: 350px;
      border-radius: 12px;
      position: relative;
      overflow: hidden;
      &::after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(115,115,115,0.41);
        z-index: 2;
      }
      &.bg1 {
        background: url(https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/news-bg.png) left top / 1400px 820px no-repeat;
      }
      &.bg2 {
        background: url(https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/news-bg.png) right top / 1400px 820px no-repeat;
      }
      &.bg3 {
        background: url(https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/news-bg.png) left bottom / 1400px 820px no-repeat;
      }
      &.bg4 {
        background: url(https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/news-bg.png) right bottom / 1400px 820px no-repeat;
      }
      .title {
        position: relative;
        margin-top: 60px;
        z-index: 3;
        height: 120px;
      }
      
    }
  }
}



// 小分比率适配
@media screen and (max-width: 1560px) {
  .law-page {
    min-width: 1200px;
    .top-banner {
      height: 540px;
      .banner-info {
        height: 540px;
        .title {
          font-size: 66px;
          line-height: 84px;
        }
        .space {
          height: 22px;
        }
        .info {
          font-size: 18px;
        }
        .btn {
          margin-top: 34px;
        }
      }
    }
    .news-main {
      width: 1200px;
      .service-box {
        height: 540px;
        .table-img {
          width: 600px;
        }
        .info-box {
          width: 600px;
          padding-left: 42px;
          font-size: 21px;
          line-height: 36px;
          .title {
            margin-bottom: 18px;
          }
        }
      }

      .section-title {
        margin-bottom: 52px;
        h2 {
          font-size: 42px;
        }
        .title-underline {
          width: 380px;
          height: 6px
        }
      }

      .scene-box {
        gap: 24px;
        .item {
          width: 580px;
          height: 280px;
          .title {
            height: 108px;
          }
          &.bg1 {
            background: url(https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/news-bg.png) left top / 1200px 700px no-repeat;
          }
          &.bg2 {
            background: url(https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/news-bg.png) right top / 1200px 700px no-repeat;
          }
          &.bg3 {
            background: url(https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/news-bg.png) left bottom / 1200px 700px no-repeat;
          }
          &.bg4 {
            background: url(https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/news-bg.png) right bottom / 1200px 700px no-repeat;
          }
        }
      }
    }
  }
}


// 小分比率适配
@media screen and (max-width: 1400px) {
  .law-page {
    min-width: 1080px;
    .top-banner {
      height: 500px;
      .banner-info {
        height: 500px;
        .title {
          font-size: 60px;
          line-height: 72px;
        }
        .space {
          height: 20px;
        }
        .info {
          font-size: 16px;
        }
        .btn {
          margin-top: 30px;
        }
      }
    }

    .news-main {
      width: 1080px;
      .section-title {
        margin-bottom: 36px;
        h2 {
          font-size: 36px;
        }
        .title-underline {
          width: 350px;
          height: 5px
        }
      }

      .scene-box {
        gap: 20px;
        .item {
          width: 520px;
          height: 250px;
          .title {
            height: 100px;
            margin-top: 48px;
          }
          &.bg1 {
            background: url(https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/news-bg.png) left top / 1080px 640px no-repeat;
          }
          &.bg2 {
            background: url(https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/news-bg.png) right top / 1080px 640px no-repeat;
          }
          &.bg3 {
            background: url(https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/news-bg.png) left bottom / 1080px 640px no-repeat;
          }
          &.bg4 {
            background: url(https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/news-bg.png) right bottom / 1080px 640px no-repeat;
          }
        }
      }

      .service-box {
        height: 500px;
        .table-img {
          width: 540px;
        }
        .info-box {
          width: 540px;
          padding-left: 40px;
          font-size: 19px;
          line-height: 32px;
          .title {
            margin-bottom: 18px;
          }
        }
      }
    }
  }
}

</style>